module.exports = __webpack_public_path__ + "img/set_alert.826b685f.svg";